import { render, staticRenderFns } from "./codeRuleList.vue?vue&type=template&id=0ba752b2&scoped=true"
import script from "./codeRuleList.vue?vue&type=script&lang=js"
export * from "./codeRuleList.vue?vue&type=script&lang=js"
import style0 from "./codeRuleList.vue?vue&type=style&index=0&id=0ba752b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba752b2",
  null
  
)

export default component.exports